export enum PRICE_TYPE {
  FREE = "Free",
  RECURRING = "Recurring",
  FIXED = "Fixed",
}

export enum BILLED {
  DAY = "Daily",
  MONTH = "Monthly",
  YEAR = "Yearly",
}
